import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import { LoadingButton } from "@mui/lab";

import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";
import { ChartOfAccountFormDialog } from "../chart-of-account-form-dialog";

export const EditChartOfAccountFormDialog = ({
  onClose,
  chartOfAccountId,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchChartOfAccount = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiClient.get(`chart-of-accounts/${chartOfAccountId}`, {
          params: {
            withParent: true,
          },
        });

        const {
          id,
          code,
          name,
          parent: parentChartOfAccount,
          type,
          deactivatedAt,
        } = data;

        const shouldHaveParent = Boolean(parentChartOfAccount);

        setDefaultValues({
          id,
          code,
          name,
          hasParent: shouldHaveParent,
          parentChartOfAccount: shouldHaveParent ? parentChartOfAccount : null,
          type,
          isActive: !deactivatedAt,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchChartOfAccount();
  }, [chartOfAccountId]);

  const handleSubmit = async ({ code, name, parentId, type, isActive }) => {
    try {
      await apiClient.put(`chart-of-accounts/${chartOfAccountId}`, {
        code,
        name,
        parentId,
        type,
        isActive,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui akun"));

      throw error;
    }
  };

  return (
    <ChartOfAccountFormDialog
      isOpen
      onClose={onClose}
      dialogTitle="Ubah Template Akun"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <LoadingButton loading={isLoading} variant="contained" type="submit">
          Simpan
        </LoadingButton>
      )}
    />
  );
};

EditChartOfAccountFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  chartOfAccountId: PropTypes.string,
};
